// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yCFz","rootMobile":"styles_rootMobile__3YIoX"};